export const createTooltipProps = ({
    backgroundColor = 'white',
    textColor = 'black',
    arrowColor = 'white',
    padding = 0,
    boxShadow = '0px 4px 20px rgba(0, 0, 0, 0.15)',
    fontSize,
    fontFamily,
    maxWidth = 'none',
    offset = null,
} = {}) => {
    const tooltipProps = {
        componentsProps: {
            tooltip: {
                sx: {
                    backgroundColor,
                    color: textColor,
                    boxShadow,
                    padding,
                    ...(fontSize && { fontSize }),
                    ...(fontFamily && { fontFamily }),
                    maxWidth,
                },
            },
            arrow: {
                sx: {
                    color: arrowColor,
                },
            },
        },
    };

    if (offset) {
        tooltipProps.slotProps = {
            popper: {
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset,
                        },
                    },
                ],
            },
        };
    }

    return tooltipProps;
};

export const getCopyButtonTooltipProps = (theme, isMobile) =>
    createTooltipProps({
        backgroundColor: theme.palette.common.black,
        textColor: theme.palette.common.white,
        arrowColor: theme.palette.common.black,
        padding: isMobile ? '8px 16px' : '10px 20px',
        fontSize: isMobile ? '13px' : '14px',
        fontFamily: theme.typography.fontFamily,
    });
